import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { DISPLAY_CONSTS } from '../table-header.constants';

@Component({
  selector: 'app-new-item-icon',
  templateUrl: './new-item-icon.component.html',
  styleUrls: ['./new-item-icon.component.scss'],
  standalone: false,
})
export class NewItemIconComponent {
  @Input() isDisabled = false;
  @Output() addItem = new EventEmitter();

  readonly IMAGES = IMAGE_SRC;
  readonly DISP_CONSTANTS = DISPLAY_CONSTS;

  clickAddItem() {
    this.addItem.emit();
  }
}
